import React from 'react';
import { Table, Button, Popup } from 'semantic-ui-react';


const VehicleList = ({
    vehicles, activateEditRequest, deleteVehicle
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Proizvođač</Table.HeaderCell>
                <Table.HeaderCell>Model
                </Table.HeaderCell>
                <Table.HeaderCell>Tablice
                </Table.HeaderCell>
                <Table.HeaderCell>Broj šasije
                </Table.HeaderCell>
                <Table.HeaderCell>Godina nabavke
                </Table.HeaderCell>
                <Table.HeaderCell>Status
                </Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {vehicles.map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell>{!!el.manufacturer && el.manufacturer.name}</Table.Cell>
                        <Table.Cell>{el.model}</Table.Cell>
                        <Table.Cell>{el.licencePlate}</Table.Cell>
                        <Table.Cell>{el.chassisNumber}</Table.Cell>
                        <Table.Cell>{el.purchaseYear}</Table.Cell>
                        <Table.Cell>{!!el.status && el.status.name}</Table.Cell>
                        <Table.Cell verticalAlign="middle" className="text-center">
                            <Popup
                                content="Izmjena"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="pencil"
                                        size="tiny"
                                        color="green"
                                        disabled
                                        onClick={() => {
                                            activateEditRequest();
                                        }}
                                    />

                                }
                            />
                            <Popup
                                content="Brisanje"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="close"
                                        size="tiny"
                                        color="red"
                                        onClick={() => {
                                            deleteVehicle(el.id);
                                        }}
                                    />

                                }
                            />
                        </Table.Cell>
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default VehicleList;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/VehiclesList.js